import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFoundPage() {
  useSeo({ title: "Page not found", description: "The page you are looking for does not exist on the Converged Security Institute website.", noindex: true });
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid="not-found-page">
      <div className="eyebrow mb-2">Error 404</div>
      <h1 className="font-display text-4xl sm:text-5xl">This page could not be found</h1>
      <p className="text-sm text-zinc-700 mt-4">The link may be out of date or the page may have moved.</p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to="/" className="btn-terracotta px-6 py-3 rounded-full text-sm font-semibold" data-testid="not-found-home">Go to homepage</Link>
        <Link to="/courses" className="chip px-6 py-3 text-sm" data-testid="not-found-courses">View programmes</Link>
      </div>
    </div>
  );
}
